// Hero Slider

if(jQuery(".hero-slider__wrapper").length) {
    jQuery(".hero-slider__wrapper").slick({
        infinite: true,
        swipe: true,
        dots: true,
        speed: 300,
        dotsClass: 'slick-dots hero-slider__dots',
        arrows: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnFocus: false, 
        pauseOnHover: false,
        speed: 700,
        prevArrow: '<button class="hero-slider__arrow hero-slider__arrow--prev"><i></i></button>',
        nextArrow: '<button class="hero-slider__arrow hero-slider__arrow--next"><i></i></button>',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    arrows: false
                }
            },
        ]
    });
}
